import { createRouter, createWebHistory } from 'vue-router';
import Menu from '@/components/Menu';
import Home from '@/components/Home';
import RankingHome from '@/components/RankingHome';
import StarMentor from '@/components/StarMentor';
import MainBusiness from '@/components/MainBusiness'
import AboutUs from '@/components/AboutUs'
import EmpoweringCollaboration from '@/components/EmpoweringCollaboration'
import OfflineForum from '@/components/OfflineForum'
import AppointmentRegistration from '@/components/AppointmentRegistration'
import PersonalCenter from '@/components/PersonalCenter'
import Login from '@/components/Login'
import Person from '@/components/Person'
import ContactUs from '@/components/ContactUs'
import FinancialForum from '@/components/FinancialForum'
import Details from '@/components/Details'






const routes = [
    {
        path: '/', component: Menu,
        redirect:'/Home',
        children: [
            { path: '/Home', component: Home },//首页
            { path: '/RankingHome', component: RankingHome },//交易大赛
            { path: '/StarMentor', component: StarMentor },//明星导师
            { path: '/MainBusiness', component: MainBusiness },//主营业务
            { path: 'AboutUs', component: AboutUs },//关于我们
            { path: 'EmpoweringCollaboration', component: EmpoweringCollaboration },//经纪商
            { path: 'OfflineForum', component: OfflineForum },//线下论坛
            { path: 'AppointmentRegistration', component: AppointmentRegistration },//财经与日历
            { path: 'ContactUs', component: ContactUs },//排行
            { path: 'FinancialForum', component: FinancialForum },//报名
            { path: 'Details', component: Details },//详情页
            {
                path: 'PersonalCenter', component: PersonalCenter,
                redirect:'/Login',
                children:[
                    { path: '/Login', component: Login },//登录注册
                    { path: '/Person', component: Person },//个人信息

            ]
            },//个人中心
            
            
            
            

        ]
    },
  
];

const router = createRouter({
  history: createWebHistory(), // 使用 HTML5 History 模式
  routes
});

export default router;